export const TagSearchActionTypes = {
    TAG_SEARCH_DATA_FIRST: '@@tagSearch/TAG_SEARCH_DATA_FIRST',
    TAG_SEARCH_DATA_LOADING: '@@tagSearch/TAG_SEARCH_DATA_LOADING',
    TAG_SEARCH_DATA_SUCCESS: '@@tagSearch/TAG_SEARCH_DATA_SUCCESS',
    TAG_SEARCH_DATA_ERROR: '@@tagSearch/TAG_SEARCH_DATA_ERROR',
};
